import { FormattedMessage } from 'react-intl';

export const getColumns = () => {
  return [
    {
      title: 'id',
      dataIndex: 'id',
      sorter: (a, b) => (a.id || 0) - (b.id || 0),
    },
    {
      title: <FormattedMessage id="farmers.identifier" />,
      key: 'identifier',
      render: (_, record: cyrian.api.waybills.WaybillFarmerDetailResponseDto) => record.farmer?.farmerId,
      sorter: (a, b) => {
        const valA = a.farmer?.farmerId || '';
        const valB = b.farmer?.farmerId || '';
        return valA.localeCompare(valB);
      },
    },
    {
      title: <FormattedMessage id="farmers.firstName" />,
      dataIndex: ['farmer', 'firstName'],
      sorter: (a, b) => (a.farmer?.firstName || '').localeCompare(b.farmer?.firstName || ''),
    },
    {
      title: <FormattedMessage id="farmers.lastName" />,
      dataIndex: ['farmer', 'lastName'],
      sorter: (a, b) => (a.farmer?.lastName || '').localeCompare(b.farmer?.lastName || ''),
    },
    {
      title: <FormattedMessage id="waybills.farmers.section" />,
      dataIndex: 'section',
      sorter: (a, b) => (a.section || '').localeCompare(b.section || ''),
    },
    {
      title: <FormattedMessage id="waybills.farmers.netWeightKg" />,
      dataIndex: 'netWeightKg',
      sorter: (a, b) => (a.netWeightKg || 0) - (b.netWeightKg || 0),
    },
    {
      title: <FormattedMessage id="waybills.farmers.bagsCount" />,
      dataIndex: 'bagsCount',
      render: (bagsCount) => (bagsCount !== null && bagsCount !== undefined ? Math.round(bagsCount) : '-'),
      sorter: (a, b) => (a.bagsCount || 0) - (b.bagsCount || 0),
    },
    {
      title: <FormattedMessage id="waybills.farmers.purchaseDate" />,
      dataIndex: 'purchaseDate',
      render: (date) => (date ? new Date(date).toLocaleDateString() : '-'),
      sorter: (a, b) => new Date(a.purchaseDate).getTime() - new Date(b.purchaseDate).getTime(),
    },
    {
      title: <FormattedMessage id="waybills.farmers.receiptNumber" />,
      dataIndex: 'receiptNumber',
      sorter: (a, b) => (a.receiptNumber || '').localeCompare(b.receiptNumber || ''),
    },
  ];
};
